import { NgModule } from '@angular/core';
import { CartEffects } from './cart/cart.effects';
import { CartReducer } from './cart/cart.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

@NgModule({
  imports: [
    StoreModule.forFeature('cartState', CartReducer),
    EffectsModule.forFeature([CartEffects]),
  ],
})
export class CartModule {}
